/*
 * Conjoint Messages
 *
 * This contains all the text for the Conjoint component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.Conjoint';

export default defineMessages({
  instruction: {
    id: `${scope}.instruction`,
    defaultMessage: '(Instruction)',
  },
  questionPlaceholder: {
    id: `${scope}.questionPlaceholder`,
    defaultMessage:
      'Which of the following product alternatives would you choose?',
  },
  conceptLabel: {
    id: `${scope}.conceptLabel`,
    defaultMessage: 'Concept label',
  },
  attributeName: {
    id: `${scope}.attributeName`,
    defaultMessage: 'Name',
  },
  attributeType: {
    id: `${scope}.attributeType`,
    defaultMessage: 'Type',
  },
  attributeCurrency: {
    id: `${scope}.attributeCurrency`,
    defaultMessage: 'Currency',
  },
  sortable: {
    id: `${scope}.sortable`,
    defaultMessage: 'Sortable',
  },
  attributeTypes: {
    feature: {
      id: `${scope}.feature`,
      defaultMessage: 'Feature',
    },
    brand: {
      id: `${scope}.brand`,
      defaultMessage: 'Brand',
    },
    price: {
      id: `${scope}.price`,
      defaultMessage: 'Price',
    },
  },
  attributeLevels: {
    id: `${scope}.attributeLevels`,
    defaultMessage: 'Levels',
  },
  addLevel: {
    id: `${scope}.addLevel`,
    defaultMessage: 'Add Level',
  },
  levelPlaceholder: {
    id: `${scope}.levelPlaceholder`,
    defaultMessage: 'Type a level',
  },
  levelValueLabel: {
    id: `${scope}.levelValueLabel`,
    defaultMessage: 'Just the number',
  },
  errors: {
    emptyAttributeName: {
      id: `${scope}.emptyAttributeName`,
      defaultMessage: 'Please add a name for the attribute',
    },
    emptyAttributeLevels: {
      id: `${scope}.emptyAttributeLevels`,
      defaultMessage: 'Please fill out all levels',
    },
    exceededMaxLimit: {
      id: `${scope}.exceededMaxLimit`,
      defaultMessage:
        'You can add up to {maxLimit} levels levels at this attribute',
    },
    mixedPositiveWithNegativePriceValues: {
      id: `${scope}.mixedPositiveWithNegativePriceValues`,
      defaultMessage: 'Prices can either be all positive or all negative',
    },
    sameAttributePriceValues: {
      id: `${scope}.sameAttributePriceValues`,
      defaultMessage: 'All price values should be different with each other',
    },
  },
});
